import React, { useState, useEffect } from 'react';

import { Breadcrumb } from './breadcrumb/Breadcrumb';

import './BreadcrumbTrail.css';

export const BreadCrumbTrail = ({ context, navigateTo }) => {
  const [newClientGeneralBreadcrumb, setNewClientGeneralBreadcrumb] = useState(null);
  const [newClientConsentBreadcrumb, setNewClientConsentBreadcrumb] = useState(null);
  const [clientRelationsBreadcrumb, setClientRelationsBreadcrumb] = useState(null);
  const [viewClientBreadcrumb, setViewClientBreadcrumb] = useState(null);

  const [newStudyGeneralBreadcrumb, setNewStudyGeneralBreadcrumb] = useState(null);
  const [newStudySitesBreadcrumb, setNewStudySitesBreadcrumb] = useState(null);
  const [newStudyFormsBreadcrumb, setNewStudyFormsBreadcrumb] = useState(null);

  useEffect(() => {
    const breadcrumbs = context.breadcrumbs;
    if (breadcrumbs) {
      if (breadcrumbs.newClientGeneralBreadcrumb) {
        setNewClientGeneralBreadcrumb({ ...breadcrumbs.newClientGeneralBreadcrumb });
      }
      if (breadcrumbs.newClientConsentBreadcrumb) {
        setNewClientConsentBreadcrumb({ ...breadcrumbs.newClientConsentBreadcrumb });
      }
      if (breadcrumbs.clientRelationsBreadcrumb) {
        setClientRelationsBreadcrumb({ ...breadcrumbs.clientRelationsBreadcrumb });
      }
      if (breadcrumbs.viewClientBreadcrumb) {
        setViewClientBreadcrumb({ ...breadcrumbs.viewClientBreadcrumb });
      }
      if (breadcrumbs.newStudyGeneralBreadcrumb) {
        setNewStudyGeneralBreadcrumb({ ...breadcrumbs.newStudyGeneralBreadcrumb });
      }
      if (breadcrumbs.newStudySitesBreadcrumb) {
        setNewStudySitesBreadcrumb({ ...breadcrumbs.newStudySitesBreadcrumb });
      }
      if (breadcrumbs.newStudyFormsBreadcrumb) {
        setNewStudyFormsBreadcrumb({ ...breadcrumbs.newStudyFormsBreadcrumb });
      }
    }
  }, [context]);

  return (
    <div className="breadcrumb-trail-container">
      {newClientGeneralBreadcrumb && (
        <Breadcrumb
          breadcrumb={newClientGeneralBreadcrumb}
          color="#077187"
          shiftLeftBy={-10}
          zIndex={1}
          navigateTo={navigateTo}
        />
      )}
      {newClientConsentBreadcrumb && (
        <Breadcrumb
          breadcrumb={newClientConsentBreadcrumb}
          color="#a7c6ae"
          shiftLeftBy={-10}
          zIndex={1}
          navigateTo={navigateTo}
        />
      )}
      {clientRelationsBreadcrumb && (
        <Breadcrumb
          breadcrumb={clientRelationsBreadcrumb}
          color="#dfab26"
          shiftLeftBy={-10}
          zIndex={1}
          navigateTo={navigateTo}
        />
      )}
      {viewClientBreadcrumb && (
        <Breadcrumb
          breadcrumb={viewClientBreadcrumb}
          color="#dfab26"
          shiftLeftBy={-10}
          zIndex={1}
          navigateTo={navigateTo}
        />
      )}
      {newStudyGeneralBreadcrumb && (
        <Breadcrumb
          breadcrumb={newStudyGeneralBreadcrumb}
          color="#077187"
          shiftLeftBy={-10}
          zIndex={1}
          navigateTo={navigateTo}
        />
      )}
      {newStudySitesBreadcrumb && (
        <Breadcrumb
          breadcrumb={newStudySitesBreadcrumb}
          color="#077187"
          shiftLeftBy={-10}
          zIndex={1}
          navigateTo={navigateTo}
        />
      )}
      {newStudyFormsBreadcrumb && (
        <Breadcrumb
          breadcrumb={newStudyFormsBreadcrumb}
          color="#077187"
          shiftLeftBy={-10}
          zIndex={1}
          navigateTo={navigateTo}
        />
      )}
    </div>
  );
};
